import React, { useState, useEffect } from 'react'
import LiveModal from 'live/components/ui/Modal'
import { Text } from '../controllers/Text'
import { ChooseFile } from './ChooseFile'
import { Database, SpreadsheetHeader, TemplateHeaderPreview } from '../main/options/model/types'
import { SelectExactTab, defaultTabSelected, tabSelected } from './SelectTab'
import SelectPerspectives from '../main/options/model/edit/SelectPerspectives'
import { Toggle } from '../main/options/model/Toggle'
import i18n from 'live/services/i18n'
import { GeneralInformation } from './GeneralInformation'
import { checkCollection, checkIsValid } from './helper/GeneralInformation'
import { createDatabase, createDatabaseByFile } from '../../api/createDatabase'
import { MAIN_TABLE_MODE } from '../main/MainTable'

const ActionConfirmationDialog = require('live/components/actions/ui/confirmation-dialog')
//TODO: MOVE THIS VAR
const DEFAULT_DATASOURCE = {
    eventType: '',
    headers: [],
    keys: [],
    perspective: 0,
    skipRealtime: false,
    databaseName: '',
    dateReference: false,
    rules: []
}
function NewDatabase({
    show = false,
    onHide,
    history,
    updateModels
}: {
    show: boolean
    onHide: () => void
    history: any
    updateModels: any
}) {
    const [template, setTemplate] = useState<TemplateHeaderPreview>()
    const [tabOption, setTabOption] = useState<tabSelected>(defaultTabSelected)
    const [database, setDatabase] = useState<Database>(DEFAULT_DATASOURCE)
    const [isValid, setIsValid] = useState<boolean>(false)
    const hide = () => {
        setTemplate(undefined)
        setTabOption(defaultTabSelected)
        setDatabase(DEFAULT_DATASOURCE)
        setIsValid(false)
        onHide()
    }
    const getTitle = (): string => {
        if (tabOption.indexOf >= 0) {
            return 'New Database'
        } else {
            return 'Database Configuration'
        }
    }
    useEffect(() => {
        setTabOption(() => defaultTabSelected)
    }, [template])
    useEffect(() => {
        if (tabOption.indexOf >= 0) {
            const sheet = template.sheetData[tabOption.indexOf]
            const headers = sheet?.header || []
            setDatabase(() => ({
                ...DEFAULT_DATASOURCE,
                headers
            }))
        } else setDatabase(() => DEFAULT_DATASOURCE)
    }, [tabOption])
    
    return (
        <LiveModal show={show} backdrop="static" keyboard={false} onHide={hide}>
            <LiveModal.Header style={{ backgroundColor: 'var(--gray-100)' }}>
                <LiveModal.Title>
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between'
                        }}
                    >
                        <b>{getTitle()}</b>
                        <i
                            className="far fa-times"
                            style={{
                                padding: '12px 15px',
                                color: 'var(--gray-600)',
                                cursor: 'pointer'
                            }}
                            onClick={() => hide()}
                        />
                    </div>
                </LiveModal.Title>
            </LiveModal.Header>
            <LiveModal.Body style={{ backgroundColor: 'var(--gray-100)' }}>
                <ChooseFile setTemplate={setTemplate} tab={tabOption} />
                <SelectExactTab template={template} tabSelected={tabOption} setTab={setTabOption} />
                <div style={{ height: '320px', display: tabOption.indexOf > -1 ? 'block' : 'none' }}>
                    <GeneralInformation
                        editEventType={true}
                        isValid={isValid}
                        setIsValid={setIsValid}
                        database={database}
                        setDatabase={curr => setDatabase(() => curr)}
                    />
                </div>
            </LiveModal.Body>
            <LiveModal.Title style={{ display: tabOption.indexOf > -1 ? 'block' : 'none' }}>
                <div className="modal-actions" style={{ padding: '0px 15px' }}>
                    <button
                        className={'btn btn-sm btn-bold btn-primary'}
                        disabled={!isValid}
                        onClick={() => {
                            console.log(template,tabOption)
                            createDatabaseByFile(
                                database,
                                template.uid,
                                template.fileName,
                                String(tabOption.indexOf)
                            ).then(() => {
                                history.push({
                                    pathname: '/datasorce',
                                    search: `?${new URLSearchParams({
                                        query: '',
                                        mode: MAIN_TABLE_MODE.EDIT,
                                        eventType: database.eventType,
                                        param: ''
                                    })}`
                                })
                                updateModels()
                                hide()
                            })
                        }}
                    >
                        {i18n('save')}
                    </button>
                    <button className={'btn btn-default btn-bold btn-sm btn-test'} onClick={onHide}>
                        {i18n('cancel')}
                    </button>
                </div>
            </LiveModal.Title>
        </LiveModal>
    )
}

export { NewDatabase }
